// extracted by mini-css-extract-plugin
module.exports = {"noteContainer":"note_noteContainer__LFyHE","header":"note_header__YoKri","content":"note_content___AKE2","sizeSelect":"note_sizeSelect__f8oAh"};